import React, { PureComponent } from 'react';
import { Icon, Row, Col } from 'antd';
import { cloneDeep } from 'lodash';
import { LinkType, UploadPicture } from '../../../tools';
import { LinkTypeMode } from '../../../../types';
import './index.less';

const getImageSize = (imageUrl: string, callback: Function) => {
    const img = new Image();
    img.onload = function() {
        const width = img.width;
        const height = img.height;
        callback(null, width, height);
    };
    img.onerror = function() {
        callback('Failed to load image', null, null);
    };
    img.src = imageUrl;
};

//图片广告位项
export class ImageAdItem extends PureComponent<{
    sourceRoot?: {
        image?: string;
    };
    items?: Array<any>;
    index?: number;
    onChange?: (value: any) => void;
    item?: any;
    uploadAction?: string;
    linkTypes?: Array<any>;
    linkTypeMode?: LinkTypeMode;
    effectiveTime?: { start: string; end: string };
    selector: any;
    showDescribe?: any;
}> {
    state = {
        uploadLoading: false,
    };
    change = (item: any) => {
        const { items, index, onChange } = this.props;
        let newItems = cloneDeep(items);
        newItems.splice(index, 1, item);
        onChange(newItems);
    };

    changeEffectiveTime = (time: any) => {
        const { item } = this.props;
        this.change({ ...item, ...time });
    };

    onUpload = (path) => {
        const { item } = this.props;
        let newItem = cloneDeep(item);
        getImageSize(path, (err: any, width: any, height: any) => {
            if (!err) {
                newItem.pic = `${path}?width=${width}&height=${height}`;
                this.change(newItem);
            } else {
                newItem.pic = path;
                this.change(newItem);
            }
        });
    };

    removeItem = () => {
        const { items, onChange, index } = this.props;
        let newValue = cloneDeep(items);
        newValue.splice(index, 1);
        onChange(newValue);
    };

    render() {
        const {
            item,
            linkTypes,
            linkTypeMode,
            uploadAction,
            selector,
            sourceRoot,
            showDescribe,
        } = this.props;
        return (
            <Row className="entry-item">
                <Icon type="close" className="item-remove" title="移除" onClick={this.removeItem} />
                <Col className="entry-item-image" span={4}>
                    <UploadPicture
                        sourceRoot={sourceRoot}
                        value={item.pic}
                        uploadAction={uploadAction}
                        onChange={this.onUpload}
                    />
                </Col>
                <Col className="entry-item-content" span={19}>
                    <LinkType
                        showDescribe={showDescribe || false}
                        selector={selector}
                        linkTypes={linkTypes}
                        linkTypeMode={linkTypeMode}
                        value={item}
                        onChange={this.change}
                    />
                </Col>
            </Row>
        );
    }
}
